import { faDizzy } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Link } from 'react-router-dom';
import FaIconView from '../../components/FaIconView/FaIconView';
import './not_found.scss';

const NotFound: React.FC = () => {
  return (
    <div className="wrapper">
      <FaIconView
        icon={faDizzy}
        iconSize="7x"
        iconStyle="grey-icon icon"
        label="عذراً هذه الصفحة غير موجودة"
        labelStyle="label"
      />
      <Link to="/" className="label underlined">
        انتقل إلى الصفحة الرئيسية
      </Link>
    </div>
  );
};

export default NotFound;
